export const FINANCIAL_PRODUCT_ORDER = ['STANDARD', 'BALLOON', 'LEASING'] as const;
